var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSuccess32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconSuccess32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.8326394,0.00944836546 31.9905516,7.1673606 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16,2.28571429 C8.42580915,2.28571429 2.28571429,8.42580915 2.28571429,16 C2.28571429,23.5741909 8.42580915,29.7142857 16,29.7142857 C23.5707965,29.7060973 29.7060973,23.5707965 29.7142857,16 C29.7142857,8.42580915 23.5741909,2.28571429 16,2.28571429 Z M21.0742857,10.7851429 C21.5046991,10.339503 22.1420764,10.1607784 22.7414411,10.317662 C23.3408059,10.4745456 23.8088829,10.9426227 23.9657666,11.5419874 C24.1226502,12.1413522 23.9439256,12.7787295 23.4982857,13.2091429 L23.4982857,13.2091429 L14.3554286,22.352 C13.689127,23.0181307 12.6101269,23.0217035 11.9394286,22.36 L11.9394286,22.36 L7.368,17.8514286 C6.69389701,17.1864777 6.68647773,16.1009601 7.35142857,15.4268571 C8.01637941,14.7527542 9.10189701,14.7453349 9.776,15.4102857 L9.776,15.4102857 L13.1348571,18.7245714 L21.0742857,10.7862857 Z",
    id: "Combined-Shape",
    fill: "#177D3D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSuccess32);
export default __webpack_public_path__ + "static/media/messageSuccess32.f97afe7c036e44843f9d08699abc8983.svg";
export { ForwardRef as ReactComponent };